module.exports = __webpack_public_path__ + "img/logo_.7e4b3af3.svg";